import { Component, Input, OnInit } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-supporting-text',
    templateUrl: './supporting-text.component.html',
    styleUrls: ['./supporting-text.component.scss']
})
export class SupportingTextComponent extends BaseViewComponent implements OnInit {
    @Input() isViewOnly: boolean = false;
}
